export default {
  common__validation__is_required: 'Pole jest wymagane',
  common__validation__invalid_format: 'Nieprawidłowa wartość',
  common__validation__invalid_file_size: 'Rozmiar pliku przekracza maksymalny limit ({size})',
};
